import styled from 'styled-components';

export const Container = styled.div`
  background: rgba(255,255,255,0.8);
  width: 100%;
  z-index: 10000;
  height: auto;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease;

  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
  border-left: 1px solid rgba(0,0,0, 0.2);

  button {
    background: none;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.5;
    }
  }

  header {
    display: flex;
    flex-direction: row;
    float: left;
    width: 100%;
    align-items: center;
    background: rgba(0, 0, 0, 0.05);
    padding: 2rem;
    border-bottom: 1px solid rgba(0,0,0, 0.2);

    div {
      margin: 0 0px;
      flex: 1;
      float: left;
    }

    h1 {
      color: #333;
      font-size: 26px;
      font-weight: 700;
    }

    h2 {
      color: #666;
      font-weight: normal;
      font-size: 14px;
      opacity: 0.8;
    }
  }

  ul {
    list-style: none;
    float: left;
    width: 100%;
    background: rgba(0, 0, 0, 0.02);
    padding: 20px;

    li {
      display: flex;
      flex-direction: row;
      float: left;
      width: 100%;
      list-style: none;
      border: 2px solid rgba(0,0,0, 0.1);
      border-radius: 4px;
      background: rgba(255,255,255, 0.4);
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.02);
      transition: all 0.5s ease;

      &:hover {
        background: rgba(255,255,255, 0.8);
        text-decoration: underline;
      }

      p {
        padding: 20px;
        display: flex;
        font-size: 18px;
        flex: 1;
        color: #333;
        border-right: 2px solid rgba(0,0,0,0.02);
        flex-direction: column;

        strong {
          font-size: 10px;
          margin: 0px;
          padding: 0px;
          color: #666;
        }

        small {
          font-size: 8px;
          color: #666;
        }
      }

      button {
        padding: 0 15px;
      }
    }
  }

  @media (max-width: 1024px) {
    width: 100%;
    height: 100%;
    overflow-y: auto;

    header {
      padding: 10px;

      > svg:first-child {
        display: none;
      }

      h1 {
        font-size: 16px;
      }
      h2 {
        font-size: 16px;
      }
    }

    ul {
      padding: 10px;

      li {
        padding: 5px;

        p {
          font-size: 12px;
        }
      }
    }
  }
`;
